export enum SampleView {
    LIST = 'List view',
    GRID = 'Grid view',
    REVIEWANDCONFIRM = 'Review and confirm'
}
